const Schema = () => ({
  fieldsets: [{ id: 'default', title: 'Default', fields: [] }],
  properties: {},
  required: [],
  title: 'Styled text',
});

export default Schema;
